import { Component,OnInit } from '@angular/core';
import { NavController, NavParams,Refresher,LoadingController,ToastController } from 'ionic-angular';
import { Usuario } from '../../entities/usuario';
import { Api } from '../../providers/api/api';
import { TabelaMedidaCapa } from '../../entities/tabela-medida-capa';

@Component({
  selector: 'page-tabela-medida',
  templateUrl: 'tabela-medida.html',
})
export class TabelaMedidaPage implements OnInit {
  public usuario: Usuario;  
  referencia: string; 
  grupoDetalhe: string = "1"; 
  public obterTabelaMedida: TabelaMedidaCapa[] = [];
  
  constructor(public navCtrl: NavController, 
    private _toastCtrl: ToastController,
    private _loadingCtrl: LoadingController,
    private _api: Api, 
    public navParams: NavParams) {
      this.usuario = navParams.get('usuario');
  }

  ngOnInit(): void {

  }

  public consultarTabela(refresher?: Refresher): void {            
        //console.log(this.grupoDetalhe);
        //console.log(this.referencia); 

    let load = this._loadingCtrl.create({ content: 'Obtendo tabela de medida...' });
        if (!refresher)
            load.present();
    
        this._obterTabelaMedida(this.grupoDetalhe, this.referencia).then(obterTabela => {                  
            this.obterTabelaMedida = obterTabela;  
            
            if (!refresher) load.dismiss(); else refresher.complete();
        }).catch(error => {
            if (!refresher) load.dismiss(); else refresher.complete();
            this._toastCtrl.create({
                message: 'Ocorreu um erro ao tentar obter tabela de medida. Tente novamente!'+error,
                duration: 3000
            }).present();
        });     
  }

  private _obterTabelaMedida(grupoDetalhe: String, referencia: String): Promise<TabelaMedidaCapa[]> {
      return new Promise((resolve, reject) => {
        this._api.get(`LoteRecebido/ListaTabelaMedida/${grupoDetalhe}/${referencia}`).subscribe(response =>         
          resolve(JSON.parse(response._body)), reject);               
    
      });
    }


}



// WEBPACK FOOTER //
// ./src/pages/tabela-medida/tabela-medida.ts